// extracted by mini-css-extract-plugin
export default {"main":"DetailLayout_main__X3cBY","body":"DetailLayout_body__qAfFK"};